<template>
  <div class="ele-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @changeCompany="changeCompany" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick">
        </tab-tree>
      </div>
      <div class="grid-rightcontent">
        <btn-show @show="Btn" content="左边树"></btn-show>

        <div class="middle">
          <el-row :gutter="14" style="display: flex;height:100%">
            <el-col :span="12" style="border-radius: 4px;display: flex;height:100%">
              <State :tableData="tableData" :ifLoad="ifLoad"></State>
            </el-col>
            <el-col :span="6" style="display: flex;height:100%">
              <power-factor :factorData="power" :factorTitle="powerTitle" :ifLoad="ifLoad"></power-factor>
            </el-col>
            <el-col :span="6" style="display: flex;height:100%">
              <power-factor :factorData="deviation" :factorTitle="deviationTilte" :ifLoad="ifLoad"></power-factor>
            </el-col>
          </el-row>
        </div>
        <div class="bottom">
          <el-row :gutter="14" style="display: flex;height:100%">
            <el-col :span="12" style="display: flex;height:100%">
              <frequency-line :frequency="frequency" :ifLoad="ifLoad"></frequency-line>
            </el-col>
            <el-col :span="12" style="display: flex;height:100%">
              <real-time-three :selectedMeasure="selectedMeasure"></real-time-three>
            </el-col>
          </el-row>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector'
import TabTree from '@/components/common/TabTree.vue'
import BtnShow from '@/components/common/BtnShow.vue'
import api from '@common/api/index.js'
import { findDataByParam } from '@/utils/index.js'
import handleData from '@/utils/handleData.js'
import State from '@/components/page/ProfileInformation/State.vue'
import PowerFactor from '@/components/page/ProfileInformation/PowerFactor.vue'
import FrequencyLine from '@/components/page/ProfileInformation/FrequencyLine.vue'
import RealTimeThree from '@/components/page/ProfileInformation/RealTimeThree.vue'
import ResizeContainer from '@/components/common/resizeContainer.vue'
export default {
  name: 'ProfileInformation',
  // 引用组件
  components: {
    TabTree,
    BtnShow,
    State,
    PowerFactor,
    FrequencyLine,
    RealTimeThree,
    ResizeContainer,
  },
  data () {
    return {
      topcontent: false,
      tabShow: true,
      tableData: [],
      viewTreeData: [],
      selectedMeasure: {
        measureId: '',
        measureName: '',
      },
      ifQualified: '',
      ifLoad: true,
      deviation: [], //频率因数
      deviationTilte: '频率偏差',
      power: [], //功率因数
      powerTitle: '功率因数',
      frequency: {},
    }
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    let vm = this
    vm.selectedTab = 'voltage'
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () { },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    changeCompany (companyId) {
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        companyId,
        '/power/ProfileInformation',
        null
      )
        .then((res) => {
          const viewTreeData = findDataByParam('viewTree', true, res.data)
          this.viewTreeData = viewTreeData
        })
    },
    //获取信息概览信息
    getData () {
      let vm = this
      //信息概览
      vm.ifLoad = true
      vm.$api.tmp
        .getPowerQualityInfo(vm.selectedMeasure.measureId)
        .then((res) => {
          if (res.success) {
            vm.ifLoad = false
            let deviation = [
              { value: res.data.deviation, name: '频率偏差(Hz)' },
              { min: -0.6, max: 0.6 },
            ] //频率因数
            let power = [
              { value: res.data.power, name: '功率因数' },
              { min: -1, max: 1 },
            ] //功率因数
            vm.deviation = deviation
            vm.power = power
            vm.tableData = [] //状态概览
            for (let i in res.data.status) {
              res.data.status[i].lastweek =
                res.data.status[i].lastweek == ''
                  ? '-'
                  : res.data.status[i].lastweek + '%'
              res.data.status[i].yesterday =
                res.data.status[i].yesterday == ''
                  ? '-'
                  : res.data.status[i].yesterday + '%'
              res.data.status[i].realtime =
                res.data.status[i].realtime == ''
                  ? '-'
                  : res.data.status[i].realtime
              vm.tableData.push(res.data.status[i])
              let index = res.data.status[i].realtime.indexOf('不合格')
              if (index > -1) {
                vm.ifQualified = '不合格'
              } else {
                vm.ifQualified = '合格'
              }
            }
            let frequency = {
              series: [
                {
                  data: [],
                  name: '频率',
                  type: 'line',
                  smooth: true,
                },
              ],
              title: ['频率'],
              xData: [],
            }
            res.data.frequency.data.forEach((item) => {
              frequency.series[0].data.push(item.value.toFixed(2))
              frequency.xData.push(item.time)
            })
            vm.frequency = frequency
          } else {
            vm.$message.error(res.msg)
          }
        })
        .catch((error) => {
          vm.$message.error(error.msg)
        })
    },
    tabclick (e) {
      if (e == 'left') {
        this.topcontent = false
      } else {
        this.topcontent = true
      }
    },
    Btn () {
      let vm = this
      vm.tabShow = !vm.tabShow
      vm.getData()
    },
    //树默认点击第一条
    tabTreeDefault (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
    //树点击事件
    tabTreeClick (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
  },
}
</script>
<style lang="css">
.tabTree-wrap {
  background: #fff;
  /* height: 100%; */
}
</style>
<style lang="scss" scoped>
.ele-wrap {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
}
.person {
  height: 100%;
}
.tree-content {
  width: 100%;
  margin-right: 14px;
}
.grid-rightcontent {
  position: relative;
  height: 100%;
  color: rgba(24, 24, 24, 1);
  display: flex;
  flex-flow: column;
}
.top {
  margin-bottom: 10px;
  background: #fff;
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
}
.toptitle {
  background: #f0f3f4;
  color: rgba(24, 24, 24, 1);
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
}
.topall {
  display: flex;
}
.topright {
  display: flex;
  flex: 2;
  justify-content: center;
  align-items: center;
}
.topcontent {
  margin: 0.5%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  width: 80%;
  position: relative;
  border-radius: 4px;
  height: 85px;
  .titlebox {
    display: flex;
    width: 15%;
    align-items: center;
  }
}
.middle {
  margin-bottom: 10px;
  display: flex;
  height: calc(50% - 10px);
  flex-flow: column;
}
.middleleft {
  height: 242px;
}
.middleright {
  height: 242px;
}
.contentOne {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-size: 0.7rem;
  margin-left: 5%;
}
.content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 5%;
  span:nth-child(2) {
    margin-top: 10px;
    color: #111;
    font-size: 1.2rem;
    font-weight: bold;
  }
}
.bottom {
  display: flex;
  height: calc(100% - 50% + 10px);
  flex-flow: column;
}
.middletitleleft {
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background: #0197ee;
  color: #fff;
}
.middletitleright {
  background: #f0f3f4;
  color: rgba(24, 24, 24, 1);
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  // padding: 5px;
}
.middleleft {
  border: 1px solid #eee;
  background: #fff;
  height: 30vh;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.middleright {
  border: 1px solid #eee;
  background: #fff;
  height: 30vh;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.bottomleft {
  border: 1px solid #eee;
  background: #fff;
  height: 39vh;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.leftBottom {
  background: #d4dde1;
  position: absolute;
  top: 35%;
  left: 2%;
  line-height: 20px;
  height: 20px;
  cursor: pointer;
}
.rightbottom {
  background: #d4dde1;
  position: absolute;
  top: 35%;
  right: 2%;
  line-height: 20px;
  height: 20px;
  cursor: pointer;
}
</style>